import Main from 'pages/Main';
import React from 'react';
import GlobalStyle from 'styles/global';

const App: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <Main />
    </>
  );
};
export default App;
